<template>
	<div>
		<span class="biaoti">分类管理</span>
		<Fenlei v-model="shu" :xianshitu="false"></Fenlei>
		<Tijiao @click="Tijiao" wenzi="保存" style="margin-top: 16px;"></Tijiao>
	</div>
</template>

<script>
	let that;
	import Fenlei from '../../zujian/Fenlei.vue'
	export default {
		data() {
			return {
				shu: [{}]
			}
		},
		components: {
			Fenlei
		},
		created() {
			that = this;
			that.CSH();
		},
		methods: {
			CSH() {
				this.$post('k=wenzhang&c=quanbufenlei', function(s) {
					if (s.shu.length>0) {
						that.shu = s.shu;
					}
				});
			},
			Tijiao() {
				this.$post('k=wenzhang&c=xiugaifenlei',{fenlei:this.shu}, function(s) {
					that.$xiaoxi(s.shu);
					if(s.shi==1){
						that.CSH();
					}
				});
			}
		}

	}
</script>

<style>

</style>
